import { useUrlParam } from "@/hooks/useTableParams";
import type { ChatListTab } from "@/types/(my-space)/chat.interface";

const TAB_VALUES: ChatListTab[] = ["all", "unread", "direct", "groups"];

/** Conversation list state in the URL: `?q=`, `?tab=`, `?view=archived`. */
export const useChatListParams = () => {
  const [search, setSearch] = useUrlParam("q", "");
  const [rawTab, setTabParam] = useUrlParam<string>("tab", "all");
  const [view, setView] = useUrlParam<string>("view", "");
  const tab: ChatListTab = TAB_VALUES.includes(rawTab as ChatListTab)
    ? (rawTab as ChatListTab)
    : "all";
  return {
    search,
    setSearch,
    tab,
    setTab: (value: ChatListTab) => setTabParam(value),
    archived: view === "archived",
    setArchived: (value: boolean) => setView(value ? "archived" : ""),
  };
};
